import { render } from "./Cursor.vue?vue&type=template&id=0528a0a4"
const script = {}
script.render = render

export default script